<template>
    <div class="topic-tree">
        <div class="label-wrapper text-truncate row">
            <div :style="indent" :class="labelClasses" class="col-11">
                <span class="label-caret" @click="toggleChildren">
                    <b-icon-caret-down-fill v-if="topics && showChildren"/>
                    <b-icon-caret-right-fill v-if="topics && !showChildren"/>
                </span>
                    <span class="label-index">{{ composeOrder(topic.order) }}</span>
                    <span class="label-title" :class="titleClass">{{ label }}</span>
            </div>
            <div class="col-1">
                <b-checkbox v-if="currentCourse" v-model="topic.status" placeholder="" :disabled="!currentCourse.status || !edit"/>
                <b-checkbox v-if="createCourse" v-model="topic.enabled" placeholder=""  />
            </div>
        </div>
        <div v-if="showChildren">
            <topic-tree-view
                v-for="topic in topics"
                :topic="topic"
                :key="topic.id"
                :topics="topic.children"
                :label="topic.title"
                :depth="depth + 1"
                :parentOrder="topic.order"
                :currentCourse="currentCourse"
                :createCourse="createCourse"
                :edit="edit"
            />
        </div>

    </div>
</template>

<script>

export default {
    name: "topic-tree-view",
    props: [ 'topics', 'label','topic', 'depth', 'parentOrder', 'currentCourse','createCourse','edit'],
    data() {
        return {
            showChildren: true,
            x: null
        }
    },
    computed: {
        iconClasses() {
            return {
                'chevron-right': !this.showChildren,
                'chevron-down': this.showChildren
            }
        },
        labelClasses() {
            return { 'has-children': this.topics }
        },
        titleClass() {
            let done = this.topic.status
            return { 'text-success': done, 'text-muted': !done }
        },
        indent() {
            return { transform: `translate(${this.depth * 25}px)` }
        }
    },
    methods: {
        toggleChildren() {
            this.showChildren = !this.showChildren;
        },
        setActiveTopic(topic) {
            this.$parent.setActiveTopic(topic);
        },
        composeOrder(topicOrder) {
            let order = '';
            if (this.parentOrder) {
                order += this.parentOrder+'.';
            }
            order += topicOrder
            return order
        },
    }
}
</script>

<style scoped>
.topic-tree .label-wrapper {

    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
}
.topic-tree .has-children {
    cursor: pointer;
}

.topic-tree .label-index {
    font-weight: bold;
    padding-right: 10px;
}
.topic-tree .label-caret {
    display: inline-block;
    width: 25px;
}
</style>



